import { Box, Typography, alpha, useTheme } from '@mui/material';
import { generateRandomColor } from 'utils/generateRandomColor';

export interface TrackCoverProps {
  title: string;
  cover?: string;
  size?: 'small' | 'medium' | 'large';
  fallback?: React.ReactNode;
}

const sizes = {
  small: 32,
  medium: 40,
  large: 64,
};

export function TrackCover({ title, cover, size = 'medium', fallback }: TrackCoverProps) {
  const theme = useTheme();
  const color = generateRandomColor(title);
  const dimension = sizes[size];

  if (cover) {
    return (
      <Box
        component="img"
        src={cover}
        sx={{
          width: dimension,
          height: dimension,
          objectFit: 'cover',
          borderRadius: 1,
          display: 'block',
          flexShrink: 0,
        }}
      />
    );
  }

  return (
    <Box
      sx={{
        width: dimension,
        height: dimension,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        borderRadius: 1,
        flexShrink: 0,
        color: theme.palette.getContrastText(color),
        border: `1px solid ${color}`,
        backgroundColor: alpha(color, 0.5),
      }}
    >
      <Typography
        noWrap
        fontWeight="bold"
        lineHeight={1.25}
        // fontSize={size === 'small' ? '.75rem' : size === 'large' ? '1.75rem' : '1.25rem'}
        fontSize={'.75rem'}
      >
        {fallback || title.replace(/[^\w]/g, '').substring(0, 2).toUpperCase()}
      </Typography>
    </Box>
  );
}
